import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import useStateRef from "react-usestateref";
import { useNavigate, useLocation } from "react-router-dom";
import { getCookie, setCookie } from "../utils/TutorConstants";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString,
} from "../utils/common-utils";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { getSchoolDetails } from "../api/login-service";
import { status } from "../utils/LearningPathUtils";
import { StorageService } from "../utils/StorageUtils";

const RootContext = createContext();

export const RootProvider = ({ children }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const profileIconRef = useRef(null);
  const pocketIconRef = useRef(null);
  const location = useLocation();
  const [userDetails, setUserDetails, userDetailsRef] = useStateRef("");
  const [selectedIndex, setSelectedIndex, selectedIndexRef] = useStateRef(-1);
  const [openDoubtSideMenu, setOpenDoubtSideMenu, openDoubtSideMenuRef] =
    useStateRef(false);
  const [openPracSideMenu, setOpenPracSideMenu, openPracSideMenuRef] =
    useStateRef(false);
  const [openProfileMenu, setOpenProfileMenu, openProfileMenuRef] =
    useStateRef(false);
  const [openEditProfile, setOpenEditProfile, openEditProfileRef] =
    useStateRef(false);
  const [registrationStatus, setRegistrationStatus, registrationStatusRef] =
    useStateRef("2");

  const [openLearnSideMenu, setOpenLearnSideMenu, openLearnSideMenuRef] =
    useStateRef(false);
  const [isReviewScreen, setReviewScreen, isReviewScreenRef] =
    useStateRef(false);
  const [taskType, setTaskType, taskTypeRef] = useStateRef();
  const [isLogout, setIsLogout, isLogoutRef] = useStateRef(false);
  const [autoPlay, setAutoPlay, autoPlayRef] = useStateRef(false);
  const [
    isRedirectObjectInserted,
    setIsRedirectedObjectInserted,
    isRedirectObjectInsertedRef,
  ] = useStateRef(false);
  const [taskId, setTaskId, taskIdRef] = useStateRef();
  const [
    timeTakenForQuestion,
    setTimeTakenForQuestion,
    timeTakenForQuestionRef,
  ] = useStateRef(0);
  const [
    schoolDetailsUpdated,
    setSchoolDetailsUpdated,
    schoolDetailsUpdatedRef,
  ] = useStateRef("");
  const [
    callForgotPasswordDirectly,
    setcallForgotPasswordDirectly,
    callForgotPasswordDirectlyRef,
  ] = useStateRef(false);
  const [
    executionHistoryLoaded,
    setExecutionHistoryLoaded,
    executionHistoryLoadedRef,
  ] = useStateRef(false);
  const [
    isExperientialLearning,
    setIsExperientialLearning,
    isExperientialLearningRef,
  ] = useStateRef(false);
  const [
    handleTakeupNextTask,
    setHandleTakeupNextTask,
    handleTakeupNextTaskRef,
  ] = useStateRef(false);
  const [isUpdatesDisplayed, setIsUpdatesDisplayed, isUpdatesDisplayedRef] =
    useStateRef(false);
  const [isDiscussFlow, setIsDiscussFlow, isDiscussFlowRef] =
    useStateRef(false);
  const [
    isSelfLearnButtonClick,
    setIsSelfLearnButtonClick,
    isSelfLearnButtonClickRef,
  ] = useStateRef(false);
  const [
    isSuccessRequestDisplayed,
    setisSuccessRequestDisplayed,
    isSuccessRequestDisplayedRef,
  ] = useStateRef(false); // pay4use learning credits success request
  const [isAuthenticated, setIsAuthenticated, isAuthenticatedRef] = useStateRef(
    () => {
      if (typeof window !== "undefined") {
        // const isLogin = StorageService.getItem("xUserId");
        // let status = isLogin != null && isLogin != "undefined" && isLogin != "";
        let status = registrationStatusRef.current;
        return status === "2" || status === "3" ? false : true;
      }
      return false;
    }
  );
  const [isTutor, setIsTutor, isTutorRef] = useStateRef(() => {
    if (typeof window !== "undefined") {
      // if (window.ENV.IS_DEFAULT_STANDALONE == undefined) {
      //   const schoolId = getCookie("schoolId");
      //   return isEmptyOrNull(schoolId) ? true : false;
      // } else {
      return window.ENV.IS_DEFAULT_STANDALONE == "true" ? true : false;
      //}
    }
    return true;
  });
  const [displayProductTour, setDisplayProductTour, displayProductTourRef] =
    useStateRef(false);
  const [showTimeLogs, setShowTimeLogs, showTimeLogsRef] = useStateRef(false);
  const [last7daysData, setLast7daysData, last7daysDataRef] = useStateRef(false);
  const [taskTypeName, setTaskTypeName] = useState("Top Priority");
  const [subTopicName, setSubTopicName, subTopicNameRef] = useStateRef("");
  const [reviewQuestionsData, setReviewQuestionsData, reviewQuestionsDataRef] =
    useStateRef("");
  const [topicName, setTopicName] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [taskCatagory, setTaskCatagory] = useState("");
  const [noOfQuestions, setNoOfQuestions, noOfQuestionsRef] = useStateRef(
    () => {
      if (typeof window !== "undefined") {
        if (window.ENV.GP_RANDOM_QUESTION_COUNT) {
          return window.ENV.GP_RANDOM_QUESTION_COUNT;
        } else {
          return 20;
        }
      }
      return 20;
    }
  );
  const [gpRandom, setGpRandom, gpRandomRef] = useStateRef(() => {
    if (typeof window !== "undefined") {
      if (isEmptyOrNull(window.ENV.GP_RANDOM)) {
        return "Coverage";
      } else {
        if (window.ENV.GP_RANDOM === "true") {
          return "Random";
        } else {
          return "Coverage";
        }
      }
    }
  });
  const [isStudentAppMapping, setIsStudentAppMapping, isStudentAppMappingRef] =
    useStateRef(() => {
      if (typeof window !== "undefined") {
        if (window.ENV.IS_STUDENTAPP_MAPPING == undefined) {
          return false;
        } else {
          return window.ENV.IS_STUDENTAPP_MAPPING == "true" ? true : false;
        }
      }
      return false;
    });
  //Playground States
  const [isPlayground, setIsPlayGround] = useState(false);
  const [rubricInfo, setRubricInfo] = useState("");
  const [playgroundMode, setPlaygroundMode] = useState("");
  const [playgroundModel, setPlaygroundModel] = useState("claude");
  const [ttsPlaygroundObj, setTtsPlaygroundObj] = useState({});
  const [isSubjectLevelDoubt, setIsSubjectLevelDoubt] = useState(false)

  async function checkAuthAndNavigate() {
    const userId = StorageService.getItem("xUserId");
    const userDetails = StorageService.getItem("user_details");
    const parsedUserDetails =
      typeof userDetails === "object" ? userDetails : JSON.parse(userDetails);
    const registrationStatus =
      parsedUserDetails?.registrationStatus !== undefined
        ? parsedUserDetails?.registrationStatus
        : "";
    let isAuth = isNotEmptyOrNull(userId);

    if (isAuth && registrationStatus === "4") {
      if (isTutorRef?.current) {
        if (location.pathname === "/practice" || location.pathname === "/") {
          navigate("/practice");
        } else {
          navigate(location.pathname);
        }
      } else {
        if (location.pathname === "" || location.pathname === "/") {
          navigate("/home", {
            replace: true,
          });
        } else {
          navigate(location.pathname);
        }
      }
    } else {
      if (location.pathname.includes("/student")) {
        console.log(location.pathname);
        let schoolName = "";
        schoolName = location.pathname.replace(`${urlString}/student/`, "");
        setCookie("schoolName", schoolName);
        let schoolId = "";
        if (location.search?.includes("&pwdrst")) {
          setCookie("isFirstTimeReset", true);
          schoolId = location.search.replace("&pwdrst", "");
        } else {
          setCookie("isFirstTimeReset", false);
        }
        setCookie("studentId", schoolId?.replace("?", ""));
        let response = await getSchoolDetails(schoolName);
        if (response?.success && response?.data?.data?._id) {
          response = response?.data;

          setCookie("school_details", JSON.stringify(response?.data));
          setCookie("schoolFullName", response?.data?.name || "");
          setSchoolDetailsUpdated(true);
          if (location.search?.includes("&pwdrst")) {
            setcallForgotPasswordDirectly(true);
          }
        } else {
          toast({
            title: status?.error,
            position: "top",
            description: response?.data?.message,
            status: status?.error,
            duration: 1500,
            isClosable: true,
            containerStyle: {
              color: "#fff",
            },
          });
          setCookie("schoolName", "");
          navigate(`${urlString}/invalid-school`, { replace: true });
        }
      } else {
        setCookie("schoolName", "");
        if (location.pathname.includes("/login")) {
          if (isStandalone) {
            navigate(location.pathname, { replace: true });
          } else {
            navigate(`${urlString}/invalid-school`, { replace: true });
          }
        } else {
          navigate(location.pathname, { replace: true });
        }
      }
    }
  }
  useEffect(() => {
    checkAuthAndNavigate();
  }, [handleTakeupNextTask]);

  const toggleDoubtDrawer = () => {
    setOpenDoubtSideMenu(!openDoubtSideMenu);
  };
  const toggleTimeLogsDrawer = () => {
    setShowTimeLogs(!showTimeLogs);
  };
  const togglePracDrawer = () => {
    setOpenPracSideMenu(!openPracSideMenu);
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toggleLearnDrawer = () => {
    if (openLearnSideMenuRef.current) {
      onClose();
      setOpenLearnSideMenu(false);
    } else {
      onOpen();
      setOpenLearnSideMenu(true);
    }
  };

  const isStandaloneWithSubjectMapping =
    isStudentAppMappingRef?.current && isTutorRef?.current;
  const isStandalone = !isStudentAppMappingRef?.current && isTutorRef?.current;

  const state = {
    selectedIndex: selectedIndexRef?.current,
    setSelectedIndex,
    openDoubtSideMenu: openDoubtSideMenuRef?.current,
    toggleDoubtDrawer,
    setOpenDoubtSideMenu,
    openLearnSideMenu: openLearnSideMenuRef?.current,
    toggleLearnDrawer,
    openPracSideMenu: openPracSideMenuRef?.current,
    togglePracDrawer,
    isAuthenticated: isAuthenticatedRef?.current,
    isTutor: isTutorRef?.current,
    userDetails: userDetailsRef?.current,
    setUserDetails,
    taskTypeName: taskTypeName,
    setTaskTypeName,
    subTopicName: subTopicNameRef?.current,
    setSubTopicName,
    topicName: topicName,
    setTopicName,
    subjectName: subjectName,
    setSubjectName,
    taskCatagory: taskCatagory,
    setTaskCatagory,
    openProfileMenu: openProfileMenuRef?.current,
    setOpenProfileMenu,
    isStandaloneWithSubjectMapping,
    isStandalone,
    setIsAuthenticated,
    setIsTutor,
    setIsStudentAppMapping,
    isStudentAppMapping: isStudentAppMappingRef?.current,
    setNoOfQuestions,
    noOfQuestions: noOfQuestionsRef.current,
    setGpRandom,
    gpRandom: gpRandomRef.current,
    openEditProfile: openEditProfileRef?.current,
    setOpenEditProfile,
    setRegistrationStatus,
    registrationStatus: registrationStatusRef?.current,
    handleTakeupNextTask: handleTakeupNextTaskRef.current,
    setHandleTakeupNextTask,
    isReviewScreen: isReviewScreenRef.current,
    setReviewScreen,
    isExperientialLearning: isExperientialLearningRef.current,
    setIsExperientialLearning,
    setIsLogout,
    isLogout: isLogoutRef.current,
    profileIconRef,
    pocketIconRef,
    taskId: taskIdRef?.current,
    setTaskId,
    setTaskType,
    taskType: taskTypeRef?.current,
    isRedirectObjectInserted: isRedirectObjectInsertedRef?.current,
    setIsRedirectedObjectInserted,
    isUpdatesDisplayed: isUpdatesDisplayedRef?.current,
    setIsUpdatesDisplayed,
    isPlayground,
    setIsPlayGround,
    rubricInfo,
    setRubricInfo,
    playgroundMode,
    setPlaygroundMode,
    playgroundModel,
    setPlaygroundModel,
    isDiscussFlow: isDiscussFlowRef?.current,
    setIsDiscussFlow,
    setIsSelfLearnButtonClick,
    isSelfLearnButtonClick: isSelfLearnButtonClickRef?.current,
    setTimeTakenForQuestion,
    timeTakenForQuestion: timeTakenForQuestionRef.current,
    setSchoolDetailsUpdated,
    schoolDetailsUpdate: schoolDetailsUpdatedRef.current,
    setcallForgotPasswordDirectly,
    callForgotPasswordDirectly: callForgotPasswordDirectlyRef.current,
    setExecutionHistoryLoaded,
    executionHistoryLoaded: executionHistoryLoadedRef.current,
    setReviewQuestionsData,
    reviewQuestionsData: reviewQuestionsDataRef.current,
    autoPlay: autoPlayRef?.current,
    setAutoPlay,
    setDisplayProductTour,
    displayProductTour: displayProductTourRef.current, ttsPlaygroundObj, setTtsPlaygroundObj,
    isSubjectLevelDoubt, setIsSubjectLevelDoubt,
    setisSuccessRequestDisplayed,
    isSuccessRequestDisplayed,
    setShowTimeLogs,
    showTimeLogs: showTimeLogsRef.current,
    toggleTimeLogsDrawer,
    setLast7daysData,
    last7daysData: last7daysDataRef.current,
  };
  return <RootContext.Provider value={state}>{children}</RootContext.Provider>;
};

export const useRoot = () => {
  return useContext(RootContext);
};
